
import { Component, Input, OnInit, QueryList, ViewChildren } from '@angular/core';
import { BehaviorSubject, Observable, Subscription } from 'rxjs';
import { SortOrders } from '../../../shared/models/sort-orders';
import { AppStore } from '../../../shared/store/lookup-store.service';
import { AuthenticationResult } from '../../../shared/models/authentication-result';
import { Navigation } from '../../../shared/models/navigation';
import { UiStateStore } from '../../../shared/store/ui-state-store.service';
import { CandidateSummary } from '../../models/candidate-summary';
import { CandidatesFilter } from '../../models/candidates-filter';
import { CandidatesStore } from '../../store/candidates-store.service';

@Component({
  selector: 'search-candidate',
  templateUrl: './search-candidate.component.html',
  styleUrls: ['./search-candidate.component.scss']
})
export class SearchCandidateComponent implements OnInit {
  @ViewChildren('dateposted') postedDateControls: QueryList<Input>;
  @ViewChildren('experience') experienceControls: QueryList<Input>;
  @ViewChildren('qualification') qualificationControls: QueryList<Input>;

  public jobKeyword: string;
  public location: string;
  public user: AuthenticationResult = null;
  _totalPageCount: BehaviorSubject<number> = new BehaviorSubject<number>(0);
  public totalPageCount: Observable<number> = this._totalPageCount.asObservable();
  _candidates: BehaviorSubject<CandidateSummary[]> = new BehaviorSubject<CandidateSummary[]>([]);
  public candidates: Observable<CandidateSummary[]> = this._candidates.asObservable();
  public navigations: Navigation[] = Navigation.getEmployerNavigations();
  selectedExperiences: number[] = [];
  selectedDatePosted: number[] = [];
  candidateFilter: CandidatesFilter;
  subscriptions: Subscription[] = [];

  constructor(
    public candidatesStore: CandidatesStore,
    public uiStore: UiStateStore,
    public lookupStore: AppStore) {
  }

  ngOnInit() {

    let userSubscription = this.uiStore.authenticatedUser.subscribe(user => {
      if (!user) {
        return;
      }

      this.user = user;
    });

    this.subscriptions.push(userSubscription);

    let filterSubscription = this.candidatesStore.candidateSearchFilter.subscribe(filter => {
      if (!filter) {
        return;
      }

      this.candidateFilter = filter;
    });

    this.subscriptions.push(filterSubscription);

    let candidatesSubscription = this.candidatesStore.candidateSearchResults.subscribe(searchResult => {
      if (!searchResult) {
        return;
      }

      this._totalPageCount.next(searchResult.pageCount);
      this._candidates.next(searchResult.result);
    });

    this.subscriptions.push(candidatesSubscription);
  }

  ngOnDestroy() {
    this.subscriptions.forEach(subscription => subscription.unsubscribe());
  }

  filterCandidates(): void {
    this.candidatesStore.loadSearchResults(this.candidateFilter);
  }

  onSortOrderChanged(event): void {
    this.candidateFilter.sortBy = event.target.value as (SortOrders);
    this.filterCandidates();
  }

  onDatePostedPeriodClicked(event, period: number): void {
    if (event.target.checked) {
      this.selectedDatePosted.push(period);
    } else {
      this.selectedDatePosted = this.selectedDatePosted.filter(x => x != period);
    }

    this.candidateFilter.datePostedPeriod = Math.max(...this.selectedDatePosted);
    this.filterCandidates();
  }

  onSectorClicked(event, id: string): void {
    if (event.target.checked) {
      this.candidateFilter.sectors.push(id);
    } else {
      this.candidateFilter.sectors = this.candidateFilter.sectors.filter(x => x != id);
    }

    this.filterCandidates();
  }

  onExperienceClicked(event, years: number): void {
    if (event.target.checked) {
      this.selectedExperiences.push(years);
    } else {
      this.selectedExperiences = this.selectedExperiences.filter(x => x != years);
    }

    this.candidateFilter.experience = Math.min(...this.selectedExperiences);
    this.filterCandidates();
  }

  onEducationLevelClicked(event, id: string): void {
    if (event.target.checked) {
      this.candidateFilter.qualifications.push(id);
    } else {
      this.candidateFilter.qualifications = this.candidateFilter.qualifications.filter(x => x != id);
    }

    this.filterCandidates();
  }

  onCandidateTitleClicked(resumeId: string): void {
    window.open(`/view-candidate/${resumeId}`);
  }

  onPagerValueChanged(args): void {
    this.candidateFilter.pageNumber = args.number;
    this.filterCandidates();
  }

}
